import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_async_linear_progress = _resolveComponent("async-linear-progress")!
  const _component_message = _resolveComponent("message")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_async_linear_progress, { task: _ctx.task }, null, 8, ["task"]),
    (!_ctx.isLoading && !_ctx.numItems)
      ? (_openBlock(), _createBlock(_component_message, { key: 0 }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }))
      : _createCommentVNode("", true)
  ]))
}